import styled from '@emotion/styled';
import React, { useState } from 'react';

import { BrowserRouter as Router } from 'react-router-dom';
import { Button, Segment, Sidebar } from 'semantic-ui-react';
import { IntlDateTimeFormatFormat } from './new/Intl/Intl.DateTimeFormat.prototype.format';
import { Menu } from './new/Menu/Menu';

const MenuButton = styled(Button)`
	position:absolute;
	top: 10px;
	left: 0px;
	z-index:999;
	border: 0 !important;
	box-shadow: none !important;

	&.ui.basic.button:active {
		background: none !important;
	}
`

function App() {
	const [isMenuVisible, setIsMenuVisible] = useState<boolean>(false);
	const [component, setComponent] = useState<JSX.Element>(<IntlDateTimeFormatFormat />);

	return (
		<Router>
			<Sidebar.Pushable as={Segment}>
				
				<Menu isVisible={isMenuVisible} onHide={() => setIsMenuVisible(false)} onSelect={(component) => setComponent(component)} />
				
				<Sidebar.Pusher>
					<>
					
						<MenuButton basic compact icon="sidebar" size="big" onClick={() => setIsMenuVisible(true)} />
						{component}
					</>
				</Sidebar.Pusher>
			</Sidebar.Pushable>
		</Router>
	);
}

export default App;
